<script lang="ts" setup>
import useStore from "@src/stores/store";
import {useAuthStore} from "@src/stores/auth";

const store = useStore();
const authStore = useAuthStore()

const handleLogout = async () => {
    await authStore.logout();
    await store.goToLogin()
    indexedDB.deleteDatabase("dChatDatabase");
}
</script>

<template>
    <div class="flex flex-col px-4 bg-white items-center justify-center h-full gap-4">
        <h1 class="text-center text-3xl font-bold md:text-7xl">403</h1>
        <div
            :style="{ backgroundImage: 'url(/images/error_animation.gif)' }"
            class="w-full h-[400px] hidden md:flex bg-center bg-no-repeat"
        >
        </div>
        <img class="md:hidden" src="/images/caveman.png">
        <h1 class="text-xl md:text-2xl font-semibold">
            Conta Bloqueada
        </h1>
        <p class="flex flex-row md:text-xl text-center">
            Sua conta está bloqueada. Por favor, entre em contato com o suporte.
        </p>
        <div class="mt-12 md:mt-6 flex-col flex text-center">
            <button
                class="py-4 px-6 mb-6 bg-indigo-500 text-white rounded-lg hover:bg-indigo-600"
            >
                <a
                    class="text-sm md:text-md"
                    href="https://wa.link/ccz074"
                    rel="noopener noreferrer"
                    role="menuitem"
                    target="_blank"
                >
                    Falar com o Suporte
                </a>
            </button>
            <a
                class="cursor-pointer underline text-gray-800 text-sm md:text-md"
                rel="noopener noreferrer"
                @click="handleLogout()"
            >
                Voltar ao login
            </a>
        </div>
    </div>
</template>

<style scoped>
</style>